<template>
  <div>
    <section class="flex flex-col w-full">
      <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
        {{ trans.get('goods.goods-list') }}
      </h1>
      <div class="flex w-full p-4 justify-between">
        <div class="w-2/3 flex">
          <div class="flex w-1/2">
            <div class="flex flex-col w-1/2">
              <label class="uppercase text-xs">
                {{ trans.get('goods.filter_by') }}
              </label>
              <div class="relative">
                <select class="w-full block appearance-none bg-gray-100 border-b rounded-none border-gray-700 text-gray-700 px-4 py-2 pr-8"
                        v-model="goodsFilter"
                        @change="filter(true)"
                >
                  <option value="" selected>{{ trans.get('goods.filter_all') }}</option>
                  <option value="active">{{ trans.get('goods.filter_active') }}</option>
                  <option value="new">{{ trans.get('goods.filter_latest') }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                  </svg>
                </div>
              </div>
            </div>
            <div class="flex flex-col w-1/2 ml-2" v-show="isOrderable">
              <label class="uppercase text-xs">
                {{ trans.get('goods.order_by') }}
              </label>
              <div class=" relative">
                <select class="w-full block appearance-none bg-gray-100 border-b rounded-none border-gray-700 text-gray-700 px-4 py-2 pr-8"
                        v-model="goodsOrder"
                        @change="filter(true)"
                >
                  <option value="end_warranty_date_asc">{{ trans.get('goods.order_warranty') }}</option>
                  <option value="created_at_desc">{{ trans.get('goods.order_created') }}</option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/3 ml-2 flex flex-col">
            <label for="serial_search">
              Search by Serial #
            </label>
            <div class="flex">
              <input
                  type="text"
                  class="border rounded px-2 py-1"
                  v-model="serial"
              >
              <button class="px-2 py-1 hover:text-blue-800" @click="searchBySerial">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <open-modal modal="goods-import" class="mr-2">
          {{ trans.get('goods.excel-import') }}
        </open-modal>
      </div>
    </section>

    <section class="w-3/4 table mx-auto rounded border shadow-lg">
      <div class="th tr">
        <div class="td" style="flex-grow: 2">
          Harp Details
        </div>
        <div class="td" style="flex-grow: 2">
          Customer Details
        </div>
        <div class="td" style="flex-grow: 2">
          Dealer Details
        </div>
        <div class="td">
          End Warranty
        </div>
      </div>

      <section>
        <div class="row"
            v-for="good in goods"
            :key="good.id"
            is="GoodRow"
            :good="good"
             @good-updated="filter"
        >

        </div>
      </section>
      <div class="flex justify-center py-2 items-center">
        <paginate :pagination="pagination" @paginate="filter" :offset="4"></paginate>
      </div>
    </section>

    <modal name="goods-import" height="auto" transition="slide" :clickToClose="false">
      <div class="flex flex-col">

        <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
          <div class="font-bold tracking-wide p-2 pl-6 uppercase">{{ trans.get('goods.goods-importer-header') }}</div>
          <div class="font-bold p-2 cursor-pointer"
               @click="$modal.hide('goods-import')">
            <i class="fas fa-times-circle"></i>
          </div>
        </div>

        <goods-importer @goods-has-been-imported="onGoodsImported"></goods-importer>

      </div>
    </modal>
  </div>
</template>

<script>

import openModal from '../buttons/openModal';
import Paginate from "../utilities/Paginate";
import GoodsImporter from "./GoodsImporter";
import GoodRow from './GoodRow';

export default {
  components: {
    openModal,
    GoodRow,
    Paginate,
    GoodsImporter
  },

  data() {
    return {
      goods: [],
      goodsFilter: 'new',
      goodsOrder: 'end_warranty_date_asc',
      pagination: {},
      sorting: {
        end_warranty_date_asc: {
          field: 'end_warranty_date',
          sort: 'asc'
        },
        end_warranty_date_desc: {
          field: 'end_warranty_date',
          sort: 'desc'
        },
        created_at_asc: {
          field: 'created_at',
          sort: 'asc'
        },
        created_at_desc: {
          field: 'created_at',
          sort: 'desc'
        },
      },
      serial: ''
    };
  },

  computed: {
    isOrderable() {
      return this.goodsFilter !== 'new' && !this.serial;
    }
  },

  created() {
    axios.get(`/warranty/goods?status=new`)
        .then(({data}) => {
          this.goods = data;
        });
  },

  methods: {
    onGoodsImported() {
      this.$modal.hide('goods-import');
      this.filter();
    },

    filter(changed = false) {
      let current_page;

      if (!changed) {
        current_page = this.pagination.current_page;
      }

      let pageNum = current_page ? current_page : 1;

      this.serial = '';

      if (this.goodsFilter === 'new') {
        axios.get(`/warranty/goods?status=new`)
            .then(({data}) => {
              this.goods = data;
              this.pagination = {};
            });
        return;
      }

      axios.get(`/warranty/goods?status=${this.goodsFilter}&order=${this.sorting[this.goodsOrder].field}&sort=${this.sorting[this.goodsOrder].sort}&paginate=25&page=${pageNum}`)
          .then(({data}) => {
            this.goods = data.data.goods;
            this.pagination = data.data.pagination;
          });
    },

    searchBySerial() {
      axios.get(`/warranty/goods/${this.serial}`)
        .then(({data}) => {
          this.goods = data;
          this.pagination = {};
          this.goodsFilter = '';
        }).catch(() => {
          this.$toastr.w(this.trans.get('goods.harp_not_found'));
      })
    }
  }
}
</script>

<style scoped>

</style>